import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import InventoryAdmin from './InventoryAdmin';
import InventorySeller from './InventorySeller';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';

export default function StockIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <InventoryAdmin />
			break;
		case '2': 
			component = <InventorySeller />
        break;
    case '3': 
			component = <InventoryAdmin />
		break;
		default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
		break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
